import { TRPCClientError } from "@trpc/client";

interface ErrorDataWithType {
    errorType?: unknown;
}

export const trpcErrorType = (error: unknown): unknown =>
    error instanceof TRPCClientError
        ? (error.data as ErrorDataWithType | undefined)?.errorType
        : undefined;
